import { defineNuxtPlugin } from '#app/nuxt'
import { LazyWidgetsArticleListWidget, LazyWidgetsArticlesWidget, LazyWidgetsBannerWidget, LazyWidgetsButtonWidget, LazyWidgetsContactFormWidget, LazyWidgetsCourseTilesWidget, LazyWidgetsFaqWidget, LazyWidgetsGalleryWidget, LazyWidgetsHeroWidget, LazyWidgetsHighlightedTextWidget, LazyWidgetsImageCardsWidget, LazyWidgetsImageWidget, LazyWidgetsImageWithMultipleLinksWidget, LazyWidgetsJotFormWidget, LazyWidgetsLargeTileWidget, LazyWidgetsLocationWidget, LazyWidgetsNewsletterWidget, LazyWidgetsPeopleWidget, LazyWidgetsQuoteWidget, LazyWidgetsTextWidget, LazyWidgetsThreeTextCardsWidget, LazyWidgetsTimetableWidget, LazyWidgetsTwoColumnsTextWidget, LazyWidgetsVideoWidget, LazyWidgetsWidescreenImageWidget } from '#components'
const lazyGlobalComponents = [
  ["WidgetsArticleListWidget", LazyWidgetsArticleListWidget],
["WidgetsArticlesWidget", LazyWidgetsArticlesWidget],
["WidgetsBannerWidget", LazyWidgetsBannerWidget],
["WidgetsButtonWidget", LazyWidgetsButtonWidget],
["WidgetsContactFormWidget", LazyWidgetsContactFormWidget],
["WidgetsCourseTilesWidget", LazyWidgetsCourseTilesWidget],
["WidgetsFaqWidget", LazyWidgetsFaqWidget],
["WidgetsGalleryWidget", LazyWidgetsGalleryWidget],
["WidgetsHeroWidget", LazyWidgetsHeroWidget],
["WidgetsHighlightedTextWidget", LazyWidgetsHighlightedTextWidget],
["WidgetsImageCardsWidget", LazyWidgetsImageCardsWidget],
["WidgetsImageWidget", LazyWidgetsImageWidget],
["WidgetsImageWithMultipleLinksWidget", LazyWidgetsImageWithMultipleLinksWidget],
["WidgetsJotFormWidget", LazyWidgetsJotFormWidget],
["WidgetsLargeTileWidget", LazyWidgetsLargeTileWidget],
["WidgetsLocationWidget", LazyWidgetsLocationWidget],
["WidgetsNewsletterWidget", LazyWidgetsNewsletterWidget],
["WidgetsPeopleWidget", LazyWidgetsPeopleWidget],
["WidgetsQuoteWidget", LazyWidgetsQuoteWidget],
["WidgetsTextWidget", LazyWidgetsTextWidget],
["WidgetsThreeTextCardsWidget", LazyWidgetsThreeTextCardsWidget],
["WidgetsTimetableWidget", LazyWidgetsTimetableWidget],
["WidgetsTwoColumnsTextWidget", LazyWidgetsTwoColumnsTextWidget],
["WidgetsVideoWidget", LazyWidgetsVideoWidget],
["WidgetsWidescreenImageWidget", LazyWidgetsWidescreenImageWidget],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
